import React from 'react';
import { FiArrowDown, FiArrowUp, FiCheck } from 'react-icons/fi';
import '../styles/TripRouteJourney.css';

const defaultRouteStops = [];

const getBadgeClassName = (type) => {
  if (type === 'stop') return 'badge_red_light';
  if (type === 'end') return 'badge_purple_light';
  return 'badge_green_light';
};

const getNodeClassName = (type) => {
  if (type === 'stop') return 'node_stop';
  if (type === 'end') return 'node_end';
  return 'node_start';
};

const RouteAction = ({ action }) => (
  <span className="action_text">
    {String(action).toLowerCase().includes('load') && !String(action).toLowerCase().includes('unload')
      ? <FiArrowUp aria-hidden="true" />
      : <FiArrowDown aria-hidden="true" />}
    {action}
  </span>
);

const TripRouteJourney = ({
  stops = defaultRouteStops,
  distanceSummary = '--',
  className = '',
}) => {
  const safeStops = Array.isArray(stops) ? stops : [];

  return (
    <div className={`route_journey_block ${className}`.trim()}>
      <div className="route_journey_header">
        <h4 className="journey_title">Route Journey</h4>
        <span className="journey_sub_info">{distanceSummary || '--'}</span>
      </div>

      {safeStops.length > 0 ? (
        <div className="route_journey_timeline">
          {safeStops.map((stop, index) => (
            <div className="timeline_step_item" key={stop.id || stop.badge || index}>
              <div className={`timeline_node ${getNodeClassName(stop.type)}`}>
                {stop.type === 'stop' ? stop.number : <FiCheck aria-hidden="true" />}
              </div>
              <div className="timeline_content">
                <div className="timeline_badges">
                  <span className={getBadgeClassName(stop.type)}>{stop.badge}</span>
                  {(Array.isArray(stop.actions) ? stop.actions : []).map((action) => (
                    <RouteAction action={action} key={`${stop.badge || index}-${action}`} />
                  ))}
                </div>
                <h5 className="stop_location_name">{stop.location || '--'}</h5>
                <p className="stop_meta_info">{stop.meta || '--'}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="route_empty_state">No route stops found.</div>
      )}
    </div>
  );
};

export { defaultRouteStops };
export default TripRouteJourney;
